import React, { Component } from 'react';
import { connect } from 'react-redux';

// constants
import CARD_REGISTER from '../cards';

// services
import { gtmCardLoadEvent } from '../services/gtmService';

/**
 *
 * Base Card Component
 * combines template a event data with other props to select card
 * from CARD_REGISTER and pass in correct props
 *
 * can render dismiss X in top right of card although this is deprecated
 *
 * Card contains main fallback catch block to hide errors in contained content.
 *   - see ComponentDidCatch -
 *
 */
class _EventFeedCard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      error: false
    };
    this.handleRemove = this.handleRemove.bind(this);
    gtmCardLoadEvent(props.userEvent.cardName);
  }

  handleRemove(cardsToTakeWithMe) {
    return this.props.removeEvent(this.props.userEvent.id, cardsToTakeWithMe);
  }

  componentDidCatch(error, info) {
    this.setState({ error: { error, info } });
  }

  renderCard() {
    const { cardTemplates, userEvent, events, groupId, passToFlowState } = this.props;

    let combinedProps = {
      thisCardName: userEvent.cardName,
      ...cardTemplates[userEvent.template][userEvent.cardName],
      ...userEvent.payload,
      id: userEvent.id,
      groupId,
      state: userEvent.state,
      dismissCard: this.handleRemove,
      passToFlowState
    };

    return CARD_REGISTER[userEvent.template](combinedProps);
  }

  renderDissmissX() {
    return (
      <i
        onClick={this.handleRemove}
        role="button"
        tabIndex="0"
        title="dismiss card"
        aria-label="Dismiss card"
        className="sa sa-times clickable-link dismiss-x"
      />);
  }

  render() {
    if (this.state.error) return null;
    const { userEvent, cardTemplates } = this.props;
    const baseClass = 'u-material-shadow-1 c-event-feed__card';
    const dismissable = cardTemplates[userEvent.template][userEvent.cardName].canDismiss !== '0';

    return (
      <div
        ref={(divElement) => { this.divElement = divElement; }}
        className={baseClass}
      >

        {dismissable ? this.renderDissmissX() : null}

        {this.renderCard()}

      </div>
    );
  }
}

const mapStateToProps = state => ({
  cardTemplates: state.eventFeed.cardTemplates,
  events: state.eventFeed.events,
});

export default connect(mapStateToProps, null)(_EventFeedCard);



// WEBPACK FOOTER //
// ./src/layout/EventFeedCard.js